var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.getCSSClass('download-label-button'),domProps:{"innerHTML":_vm._s(_vm.label)},on:{"click":_vm.download}})}
var staticRenderFns = []

export { render, staticRenderFns }